import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';

class Select extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    validateOnBlur: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    raffle: PropTypes.bool,
    register: PropTypes.bool,
  };

  constructor (props) {
    super(props);

    this.state = {
      errorMessage: null,
      status: ''
    };
  }

  onChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    if (this.props.required && this.props.validateOnBlur) {
      this.validate(event.target.value);
    }
  };

  onBlur = event => {
    if (event.target.value.length === 0) {
      this.setState({
        status: 'normal'
      });
    }

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }

    if (this.props.required && this.props.validateOnBlur) {
      this.validate(event.target.value);
    }
  };

  validate = value => {
    if (this.props.required) {
      if (value === '-1') {
        this.setState({ errorMessage: 'Lütfen Seçiniz' });
        return false;
      }
    }
    this.setState({ errorMessage: false });
  };

  render () {
    const { status, errorMessage } = this.state;
    const {
      id,
      name,
      value,
      text,
      disabled,
      options,
      raffle,
      register
    } = this.props;
    const labelText = errorMessage || name;
    const inputStatus = value || status === 'active';

    const componentClass = classnames({
      input: true,
      'input--active': inputStatus,
      'input--error': errorMessage,
      'input--disabled': disabled
    });

    return (
      <div className={ componentClass }>
        <Icon iconName={ raffle ? 'svgDownArrowRaffle' : 'svgDownArrow' }/>


        <label className={ raffle ? 'input__label-raffle' : 'input__label' }>{ labelText }</label>

        <select
          name={ id }
          id={ id }
          ref={ o => (this.refInput = o) }
          placeholder={ name }
          className="input__input input__input--select"
          value={ value }
          disabled={ disabled }
          onChange={ this.onChange }
          onBlur={ this.onBlur }
        >
          { !value && (<option value='-1' hidden>Lütfen Seçiniz</option>) }
          { register ? options?.map(item => (<option key={ item.key } value={ item.id }>{ item?.countryName }</option>))
            : options?.map(item => (<option key={ item.key } value={ item.key }>{ item.value }</option>))  }
        </select>
        <div className={ raffle ? 'input__value-raffle' : 'input__value' }>{ value && value.length && text }</div>
      </div>
    );
  }
}

export default Select;
